import { type ILogoProps, ELogoVariant } from './types';
import { DefaultLogoSvg } from './DefaultLogo';

export { ELogoVariant } from './types';
export type { TLogoVariantString } from './types';

export default function Logo({
  type = ELogoVariant.Default,
  size,
  className,
}: ILogoProps) {
  switch (type) {
    case ELogoVariant.Default:
      return <DefaultLogoSvg size={size} className={className} />;
    // Add more variants of the logo here
    default:
      return null;
  }
}
